import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import ConfirmModal from "../../../components/modal/ConfirmModal";
import ApiController from "../../../controller/ApiController";
import OrderController from "../../../controller/OrderController";
import {
  SetMenuGroupType,
  optionGroupType,
  pickGroupListType,
} from "../../../controller/StoreController";
import { useToast } from "../../../controller/ToastController";
import { adultState } from "../../../recoil/adult";
import { cartState } from "../../../recoil/cart";
import { ConfirmType, confirmState } from "../../../recoil/confirm";
import {
  LANG_CH,
  LANG_JP,
  LANG_KO,
  langState,
  langText,
} from "../../../recoil/lang";
import {
  orderDetailRealmType,
  PRODUCT_TYPE_RENTAL_DIRECT,
  PRODUCT_TYPE_RENTAL_SMS,
} from "../../../recoil/type";
import {
  getOptionTypeName,
  getPrdDescription,
  getPrdName,
} from "../../../utils/util";
import OptionList from "./optionList";
import SetOptionList from "./setOptionList";

const MenuDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeInfo, category, product } = location.state;

  const showToast = useToast();

  const [lang, setLang] = useRecoilState<number>(langState);
  const [currentConfirmState, setConfirmState] =
    useRecoilState<ConfirmType>(confirmState);
  const cart = useRecoilValue<orderDetailRealmType[]>(cartState);
  const [isCheckAdult, setIsCheckAdult] = useRecoilState<boolean>(adultState);

  const [visibleConfirm, setVisibleConfirm] = useState<boolean>(false);

  const [optionGroupList, setOptionGroupList] = useState<optionGroupType[]>([]);
  const [selectedOption, setSelectedOption] = useState<number[][]>([]);

  const [setMenuGroupList, setSetMenuGroupList] = useState<
    SetMenuGroupType | undefined
  >();
  const [pick, setPick] = useState<pickGroupListType[]>([]);

  const onCloseAdult = (value: boolean) => {
    setIsCheckAdult(true);
    setVisibleConfirm(value);
  };

  const getOptionData = async () => {
    let response = await ApiController.menu.getOptions(product.prd_id);
    if (response.ok) {
      console.log("getOptions", response.data);
      setOptionGroupList(response.data);
    }
  };
  const getSetData = async () => {
    let response = await ApiController.menu.getSetOptions(
      product.prd_id,
      storeInfo.store_id
    );

    if (response.ok) {
      if (response.data && response.data !== null) {
        console.log("getSetOptions", response.data);
        setSetMenuGroupList(response.data);
      }
    }
  };

  const checkAddCart = () => {
    if (storeInfo.store_availability_yn) {
      if (setMenuGroupList) addCart(pick);
      else addCart();
    } else {
      showToast(langText.confirmModal_closed[lang], "error");
    }
    console.log("addCart");
  };

  const addCart = (pick?: pickGroupListType[]) => {
    for (let i = 0; i < optionGroupList.length; i++) {
      let optionGroup = optionGroupList[i];
      if (
        (optionGroup.option_input_max === 1 &&
          optionGroup.option_input_min === 1) ||
        (optionGroup.option_input_max === 0 &&
          optionGroup.option_input_min === 0)
      ) {
        if (selectedOption[i].length !== 1) {
          showToast(langText.menuInfo_title_optionRequired[lang], "error");
          return false;
        }
      } else {
        if (
          optionGroup.option_input_min > selectedOption[i].length ||
          optionGroup.option_input_max < selectedOption[i].length
        ) {
          showToast(langText.menuInfo_title_optionRequired[lang], "error");
          return false;
        }
      }
    }

    if (pick) {
      for (let i = 0; i < pick.length; i++) {
        //필수선택을 다 하지 않은경우
        if (pick[i].input_min > pick[i].pick.length) {
          showToast(
            `${lang === LANG_KO || lang === LANG_JP ? i + 1 : ""}${
              langText.menuInfo_toast_select_source[lang]
            }${lang !== LANG_KO && lang !== LANG_JP ? i + 1 : ""}`,
            "error"
          );
          return;
        } else if (pick[i].pick.length > pick[i].input_max) {
          //프론트 화면로직상 해당 토스트는 발생 안하지만 에러처리
          showToast(`error configuration ${i + 1}`);
          return;
        }
      }

      //TODO 2. 선택된 상품의 옵션 검증
      for (let i = 0; i < pick.length; i++) {
        const productGroupPickList = pick[i];
        const productPickList = pick[i].pick;
        for (let j = 0; j < productPickList.length; j++) {
          const productPick = productPickList[j];
          const optionGroupPick = productPickList[j].pick;
          const optionGroupList = productPickList[j].option_group_list;

          for (let k = 0; k < optionGroupPick.length; k++) {
            const optionPick = optionGroupPick[k];
            const optionCurrentGroup = optionGroupList[k];

            if (optionCurrentGroup.option_input_min > optionPick.length) {
              if (productGroupPickList.input_min > 0) {
                showToast(
                  `${langText.menuInfo_toast_set_option_1[lang]}${
                    lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                      ? i + 1
                      : optionCurrentGroup.option_input_min
                  }${langText.menuInfo_toast_set_option_2[lang]}${
                    lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                      ? getPrdName(productPick, lang)
                      : getOptionTypeName(optionCurrentGroup, lang)
                  }${langText.menuInfo_toast_set_option_3[lang]}${
                    lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                      ? getOptionTypeName(optionCurrentGroup, lang)
                      : getPrdName(productPick, lang)
                  }${langText.menuInfo_toast_set_option_4[lang]}${
                    lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                      ? optionCurrentGroup.option_input_min
                      : i + 1
                  }${langText.menuInfo_toast_set_option_5[lang]}`,
                  "error",
                  2000
                );
              } else {
                showToast(
                  `${langText.menuInfo_toast_setOption_option_1[lang]}${
                    lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                      ? getOptionTypeName(optionCurrentGroup, lang)
                      : optionCurrentGroup.option_input_min
                  }${langText.menuInfo_toast_setOption_option_2[lang]}${
                    lang === LANG_KO || lang === LANG_CH || lang === LANG_JP
                      ? optionCurrentGroup.option_input_min
                      : getOptionTypeName(optionCurrentGroup, lang)
                  }${langText.menuInfo_toast_setOption_option_3[lang]}`,
                  "error",
                  2000
                );
              }

              return;
            } else if (
              optionPick.length > optionCurrentGroup.option_input_max
            ) {
              //프론트 화면로직상 해당 토스트는 발생 안하지만 에러처리
              showToast(
                `구성 ${i + 1}의 ${productPick.prd_name}상품의 ${
                  optionCurrentGroup.option_type_name
                }의 옵션이 많이 선택됨`,
                "error"
              );
              return;
            }
          }
        }
      }
    }

    if (product) {
      if (cart.length > 0 && cart[0].store_id !== storeInfo.store_id) {
        setConfirmState({
          visibleConfirm: true,
          successText: langText.button_add_new[lang],
          cancelText: langText.button_cancel[lang],
          handleConfirm: () => {
            OrderController.deleteCart();
            if (product) {
              if (pick) {
                OrderController.addSetCart(
                  storeInfo.store_id,
                  product,
                  category.category_id,
                  pick
                );
              } else {
                OrderController.addCart(
                  storeInfo.store_id,
                  product,
                  category.category_id,
                  optionGroupList,
                  selectedOption,
                  showToast
                  //   (product.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
                  //     product.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
                  //  rentalTime
                  //  ? rentalTime
                  //  : undefined
                );
              }
              navigate(-1);
            }
          },
          title: langText.menuInfo_other_store[lang],
        });
      } else {
        if (pick) {
          OrderController.addSetCart(
            storeInfo.store_id,
            product,
            category.category_id,
            pick
          );
        } else {
          OrderController.addCart(
            storeInfo.store_id,
            product,
            category.category_id,
            optionGroupList,
            selectedOption,
            showToast
            //  (product.prd_type === PRODUCT_TYPE_RENTAL_DIRECT ||
            //   product.prd_type === PRODUCT_TYPE_RENTAL_SMS) &&
            // rentalTime
            // ? rentalTime
            // : undefined
          );
        }
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (category.is_for_adult === 1 && !isCheckAdult) setVisibleConfirm(true);
    getOptionData();
    if (product.is_set === 1) getSetData();
  }, []);

  const RenderProductDetail = () => {
    return (
      <>
        <div className="productDetailWrap">
          <div className="detailImgWrap">
            {product.url_path ? (
              <img
                className="detailImg"
                src={product.url_path}
                alt="상품 이미지"
                width={"100%"}
              />
            ) : (
              <img
                className="detailImg"
                src={`${process.env.PUBLIC_URL}/knockknock/img/noneMenuImage.png`}
                alt="상품 이미지 없음"
                width={"100%"}
              />
            )}
          </div>
          <div className="detailTextWrap">
            {product && <h3 className="name">{getPrdName(product, lang)}</h3>}
            <h3>{product.prd_base_price_nrm}원</h3>
          </div>
        </div>
        {product.prd_description && <p>{getPrdDescription(product, lang)} </p>}
      </>
    );
  };

  return (
    <>
      <Style>
        <div className="knockContainer">
          <div className="header">
            <h3>{langText.productDetailModal_title[lang]}</h3>
            <img
              className="backIcon"
              onClick={() => {
                navigate(-1);
              }}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
              alt="back"
            />
          </div>
          <RenderProductDetail />
          {setMenuGroupList ? (
            <SetOptionList
              setMenuGroup={setMenuGroupList}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              pick={pick}
              setPick={setPick}
            />
          ) : (
            optionGroupList.length > 0 && (
              <OptionList
                option={optionGroupList}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
              />
            )
          )}
          <div className="modalFooter">
            <button onClick={checkAddCart}>
              <h2>{langText.optionModal_button_AddToCart[lang]}</h2>
            </button>
          </div>
        </div>
      </Style>
      <ConfirmModal
        isVisible={visibleConfirm}
        setVisible={onCloseAdult}
        title={langText.confirmModal_alcohol[lang]}
        confirmText={langText.button_confirm[lang]}
        icon={`${process.env.PUBLIC_URL}/knockknock/svg/ic_adult.svg`}
      />
    </>
  );
};

export default MenuDetails;

const Style = styled.div`
  .knockContainer {
    min-height: 100dvh;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    background: #000;
  }
  .header {
    padding: 20px 10px;
    position: relative;

    h3 {
      font-size: 18px;
      line-height: 24px;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
    }
    .backIcon {
      position: absolute;
      left: 4px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  /* 옵션 상세 설명 */
  .productDetailWrap {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 0 10px;
    margin-top: 20px;
    margin-bottom: 4px;

    .detailImgWrap {
      width: calc(100% / 3);
      img {
        width: 100%;
        aspect-ratio: 1 / 0.8;
        border-radius: 4px;
      }
    }
    .detailTextWrap {
      flex: 1;
      height: 100%;
      h3 {
        font-size: 18px;
        line-height: 24px;
        color: #ffffff;
        font-weight: 600;
      }
      h3.name {
        font-size: 20px;
        line-height: 24px;
        padding-bottom: 8px;
      }
    }
  }
  p {
    padding: 0 10px;
    font-size: 12px;
    line-height: 16px;
    color: #a7a7a7;
    font-weight: 400;
  }

  .modalFooter {
    position: sticky;
    bottom: 0;
    width: 100%;
    margin-top: auto;
    margin-bottom: 0;
    padding: 10px;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    background: #000000;
    button {
      width: 100%;
      padding: 12px 0;
      border-radius: 5px;
      background: #4dd2ae;
      outline: none;
      h2 {
        color: #fff;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
      }
    }
  }

  /* 옵션리스트 */
  .optionListWrap {
    padding: 20px 10px;
    padding-top: 30px;
    overflow-y: auto;
  }
  .optionName {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    h3 {
      font-size: 14px;
      font-weight: 400;
      color: #e5e5e5;
    }
    span {
      margin-left: 4px;
      font-size: 14px;
      font-weight: 400;
    }
    .require {
      color: #d14848;
    }
    .noneRequire {
      color: #327ad0;
    }
  }
  .optionButtonWrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 20px;
  }
  .optionButton {
    width: calc(94% / 3);
    min-height: 80px;
    margin: 1%;
    background: #000000;
    border: 1px solid #e5e5e5;
    padding: 8px;
    border-radius: 6px;

    h3 {
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
      color: #e5e5e5;
    }
    .optionPrice {
      margin-top: 8px;
    }
    label {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }
  }
  label input {
    display: none;
  }
  .optionButton.active {
    background: #40977f;
    padding: 7px;
    border: 2px solid #fff;

    h3 {
      color: #fff;
    }
  }
`;
